import React from "react";
import LoadingIndicator from "@ey/canvascoreservices/LoadingIndicator";
import styled from "styled-components";

interface LoadingIndicatorProps {
  show: boolean;
  styleName?: string;
  variant?: string;
  size?: string;
  tip?: string;
  view?: string;
  fullscreen?: boolean;
}

const LoadingIndicatorComponent: React.FC<LoadingIndicatorProps> = ({
  show = false,
  styleName = "inlineView",
  variant = "circular",
  size = "md",
  tip,
  view,
  fullscreen = false,
}) => {
  return (
    <StyledLoadingIndicator>
      <LoadingIndicator
        show={show}
        styleName={styleName}
        variant={variant}
        size={size}
        tip={tip}
        view={view}
        fullscreen={fullscreen}
      />
    </StyledLoadingIndicator>
  );
};

export default LoadingIndicatorComponent;

const StyledLoadingIndicator = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
